/* Ivevar mobile "Select your options" sheet on product pages (Oct 2026).
   Opens instead of a direct add-to-cart on phones; data comes from snippets/ivd-badge.liquid (pdp mode). */
(function () {
  if (window.__ivq) return;
  window.__ivq = true;

  var MQ = window.matchMedia('(max-width: 767px)');
  var TIERS = [
    { min: 400000, code: 'WELCOME30', pct: 30 }, { min: 300000, code: 'VIP25', pct: 25 },
    { min: 200000, code: 'WELCOME20', pct: 20 }, { min: 100000, code: 'WELCOME15', pct: 15 },
    { min: 29900, code: 'WELCOME10', pct: 10 }, { min: 1, code: 'IVEVAR10', pct: 10 }
  ];
  var BTN_SEL = '#add-to-cart-btn, #add-to-cart-btn1, #buy-it-now-btn1';
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var data = null, sheet = null, state = null;

  function tierFor(c) { for (var i = 0; i < TIERS.length; i++) if (c >= TIERS[i].min) return TIERS[i]; return null; }
  function money(c) {
    var n = Math.round(c) / 100;
    var s = n % 1 === 0 ? n.toLocaleString('en-US') : n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return '<span class="money">$' + s + '</span>';
  }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (m) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m]; }); }
  function metalColor(v) {
    v = v.toLowerCase();
    if (v.indexOf('rose') > -1) return '#e7a58f';
    if (v.indexOf('yellow') > -1) return '#e3bb53';
    if (v.indexOf('platinum') > -1) return '#c9ccd1';
    return '#d6d6d6';
  }
  function isMetal(name) { return /metal|gold|material/i.test(name); }
  function isCarat(name) { return /diamond|carat|\bct\b|stone size|weight/i.test(name); }

  /* ---------- Metal selector: SILVER / GOLD / PLATINUM tabs + colour circles (shared by page + sheet) ---------- */
  var WA = 'https://wa.me/919265051773?text=';
  var FILL = {
    White: 'linear-gradient(145deg,#ffffff 0%,#ebebeb 45%,#c8c8c8 100%)',
    Yellow: 'linear-gradient(145deg,#fdf3d2 0%,#efd58f 50%,#d6ad52 100%)',
    Rose: 'linear-gradient(145deg,#fde5dc 0%,#f2b9a3 50%,#dc8b6f 100%)'
  };
  var CORDER = { White: 0, Yellow: 1, Rose: 2 };
  function cap(w) { return w.charAt(0).toUpperCase() + w.slice(1).toLowerCase(); }
  function parseMetal(v) {
    var m = String(v).match(/(\d{1,2})\s*K[T]?\s+(White|Yellow|Rose)\s+Gold/i);
    if (m) return { g: 'gold', k: m[1] + 'K', c: cap(m[2]) };
    if (/silver/i.test(v)) return { g: 'silver' };
    if (/platinum/i.test(v)) return { g: 'platinum' };
    return null;
  }
  function metalOk(values) { return values.length > 1 && values.every(function (v) { return !!parseMetal(v); }); }
  function goldList(values) {
    return values.filter(function (v) { return parseMetal(v).g === 'gold'; }).sort(function (a, b) {
      var pa = parseMetal(a), pb = parseMetal(b);
      return (parseInt(pa.k, 10) - parseInt(pb.k, 10)) || (CORDER[pa.c] - CORDER[pb.c]);
    });
  }
  var lastGold = null;
  // value to select for a tab, or '' when the product has no such metal (platinum on request)
  function valueForTab(tab, values, cur) {
    if (tab === 'gold') {
      var gl = goldList(values);
      if (cur && parseMetal(cur).g === 'gold') return cur;
      if (lastGold && gl.indexOf(lastGold) > -1) return lastGold;
      return gl[0] || '';
    }
    for (var i = 0; i < values.length; i++) if (parseMetal(values[i]).g === tab) return values[i];
    return '';
  }
  function metalHTML(values, cur, plating, platNA, avail, chosen) {
    var p = !chosen ? {} : (platNA ? { g: 'platinum' } : (parseMetal(cur) || {}));
    if (p.g === 'gold') lastGold = cur;
    var has = { silver: false, gold: false, platinum: false };
    values.forEach(function (v) { var g = parseMetal(v).g; if (g in has) has[g] = true; });
    var label = !chosen ? 'Select Metal Type' : (platNA ? 'Platinum' : (p.g === 'silver' ? 'Solid ' + esc(cur) + ' &middot; ' + plating + ' Gold Plated' : esc(cur)));
    var h = '<p class="ivm__label" style="color:#111"><b>Metal:</b> <span>' + label + '</span></p><div class="ivm__tabs">';
    ['silver', 'gold', 'platinum'].forEach(function (t) {
      if (t !== 'platinum' && !has[t]) return;
      var na = t === 'platinum' && !has.platinum;
      h += '<button type="button" class="ivm__tab' + (p.g === t ? ' is-on' : '') + (na ? ' is-na' : '') + '" data-m-tab="' + t + '" aria-pressed="' + (p.g === t) + '"' + (na ? ' disabled title="Coming soon" style="opacity:.6;cursor:not-allowed;border-color:#b3b3b3;color:#4a4a4a"' : (p.g === t ? '' : ' style="border-color:#a6a6a6;color:#3d3d3d"')) + '>' + t.toUpperCase() + '</button>';
    });
    h += '</div>';
    if (p.g === 'gold') {
      h += '<div class="ivm__dots">';
      goldList(values).forEach(function (v) {
        var q = parseMetal(v), on = v === cur, na = avail && !avail(v);
        h += '<button type="button" class="ivm__dot' + (on ? ' is-on' : '') + (na ? ' is-na' : '') + '" data-m-val="' + esc(v) + '" title="' + esc(v) + '" aria-label="' + esc(v) + '" aria-pressed="' + on + '"><span style="background:' + FILL[q.c] + '">' + q.k + '</span></button>';
      });
      h += '</div>';
    } else if (p.g === 'silver') {
      h += '<div class="ivm__dots">';
      ['Yellow', 'Rose', 'White'].forEach(function (c) {
        var on = plating === c;
        h += '<button type="button" class="ivm__dot ivm__dot--silver' + (on ? ' is-on' : '') + '" data-m-plate="' + c + '" title="Solid 925 Silver, ' + c + ' Gold Plated" aria-label="Solid 925 Silver, ' + c + ' Gold Plated" aria-pressed="' + on + '" style="width:84px;gap:6px"><span style="background:' + FILL[c] + ';width:58px;height:58px;flex-direction:column;font-size:10.5px;line-height:1.15;text-align:center">Solid<br>Silver</span><em style="font-style:normal;font-size:12px;line-height:1.25;text-align:center;color:' + (on ? '#0b2a4a;font-weight:700' : '#444') + '">' + c + ' Gold<br>Plated</em></button>';
      });
      h += '</div>';
    }
    if (chosen && !platNA && (p.g === 'silver' || p.g === 'gold' || p.g === 'platinum')) {
      var buy = p.g === 'silver' ? 'Solid 925 Sterling Silver &middot; ' + plating + ' Gold Plated' : (p.g === 'gold' ? p.k + ' ' + p.c + ' Gold' : esc(cur));
      h += '<p class="ivm__buy"><span>You\'re buying:</span> <b>' + buy + '</b></p>';
    }
    return h;
  }
  window.__ivmPlating = window.__ivmPlating || 'White';

  function load() {
    var el = document.querySelector('script[data-ivq]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }
  function findVariant(opts) {
    for (var i = 0; i < data.variants.length; i++) {
      var v = data.variants[i], ok = true;
      for (var j = 0; j < opts.length; j++) if (v.options[j] !== opts[j]) { ok = false; break; }
      if (ok) return v;
    }
    return null;
  }
  function currentVariantId() {
    var input = document.querySelector('form[action*="/cart/add"] [name="id"]');
    return input && input.value ? parseInt(input.value, 10) : null;
  }

  function build() {
    sheet = document.createElement('div');
    sheet.className = 'ivq';
    sheet.setAttribute('role', 'dialog');
    sheet.setAttribute('aria-modal', 'true');
    sheet.setAttribute('aria-label', 'Select your options');
    sheet.innerHTML = '<div class="ivq__overlay" data-ivq-close></div><div class="ivq__panel"><div class="ivq__grip"></div>' +
      '<div class="ivq__head"><p class="ivq__title">Select your options</p><button type="button" class="ivq__x" data-ivq-close aria-label="Close">&times;</button></div>' +
      '<div class="ivq__body"></div><div class="ivq__foot"><p class="ivq__err" hidden></p><button type="button" class="ivq__add">Add to cart</button></div></div>';
    document.body.appendChild(sheet);
    sheet.addEventListener('click', onSheetClick);
  }

  function render() {
    var v = findVariant(state.opts);
    var body = sheet.querySelector('.ivq__body');
    var price = v ? v.price : 0;
    var t = tierFor(price);
    var h = '<div class="ivq__prod"><img src="' + esc(data.image) + '" alt="" width="64" height="64"><div><p class="ivq__pname">' + esc(data.title) + '</p>' +
      '<p class="ivq__price">' + money(price) + '</p>' +
      (t ? '<p class="ivq__code">Extra ' + t.pct + '% off with code <b>' + t.code + '</b> &rarr; ' + money(Math.round((price - Math.floor(price * t.pct / 100)) / 100) * 100) + '</p>' : '') +
      '</div></div>';

    data.options.forEach(function (name, idx) {
      var values = [];
      data.variants.forEach(function (x) { if (values.indexOf(x.options[idx]) < 0) values.push(x.options[idx]); });
      if (values.length === 1 && values[0] === 'Default Title') return;
      if (isMetal(name) && metalOk(values)) {
        h += '<div class="ivq__group ivm ivm--sheet">' + metalHTML(values, state.opts[idx], state.plating, state.platNA, function (val) {
          var trial = state.opts.slice(); trial[idx] = val; var tv = findVariant(trial);
          if (!tv) tv = data.variants.filter(function (x) { return x.options[idx] === val; })[0];
          return tv && tv.available;
        }, state.mchosen) + '</div>';
        return;
      }
      var kind = isMetal(name) ? 'metal' : (isCarat(name) ? 'carat' : 'pill');
      h += '<div class="ivq__group"><p class="ivq__label">' + esc(name.replace(/^select\s+/i, '')) + ': <span>' + esc(state.opts[idx]) + '</span></p><div class="ivq__opts ivq__opts--' + kind + '">';
      values.forEach(function (val) {
        var trial = state.opts.slice(); trial[idx] = val;
        var tv = findVariant(trial);
        var avail = tv && tv.available;
        var sel = state.opts[idx] === val;
        var inner = esc(val);
        if (kind === 'metal') inner = '<i style="background:' + metalColor(val) + '"></i>' + esc(val.replace(/\s*gold$/i, ''));
        if (kind === 'carat') inner = '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M6 3h12l3 6-9 12L3 9z"/><path d="M3 9h18M9 3l3 18 3-18"/></svg><b>' + esc(val) + (/\bct\b/i.test(val) || !/^\d/.test(val) ? '' : ' CT') + '</b>' + (tv ? '<small>' + money(tv.price) + '</small>' : '');
        h += '<button type="button" class="ivq__opt' + (sel ? ' is-sel' : '') + (avail ? '' : ' is-na') + '" data-ivq-opt="' + idx + '" data-val="' + esc(val) + '"' + (avail ? '' : ' disabled') + '>' + inner + '</button>';
      });
      h += '</div></div>';
    });

    if (data.ring) {
      h += '<div class="ivq__group"><div class="ivq__label ivq__label--row"><p>Ring Size (US): <span>' + (state.size ? esc(state.size) : 'Select') + '</span></p><a href="/pages/find-your-ring-size" target="_blank" rel="noopener">Find ring size</a></div><div class="ivq__sizes">';
      data.sizes.forEach(function (s) {
        h += '<button type="button" class="ivq__size' + (state.size === s ? ' is-sel' : '') + '" data-ivq-size="' + esc(s) + '">' + esc(s) + '</button>';
      });
      h += '</div><p class="ivq__hint">Swipe for more sizes &rarr;</p></div>';
    }
    body.innerHTML = h;
    var add = sheet.querySelector('.ivq__add');
    add.disabled = state.platNA || !(v && v.available);
    add.textContent = state.platNA ? 'Platinum: ask price on WhatsApp' : (!v || !v.available ? 'Sold out' : (state.buy ? 'Buy it now' : 'Add to cart'));
    if (window.bucksCC && typeof bucksCC.reConvert === 'function') { try { bucksCC.reConvert(); } catch (e) {} }
    var selSize = body.querySelector('.ivq__size.is-sel');
    if (selSize) selSize.scrollIntoView({ block: 'nearest', inline: 'center' });
  }

  function open(buy) {
    if (!data) data = load();
    if (!data) return false;
    if (!sheet) build();
    var vid = currentVariantId();
    var v = null;
    data.variants.forEach(function (x) { if (x.id === vid) v = x; });
    if (!v) v = data.variants.filter(function (x) { return x.available; })[0] || data.variants[0];
    var sizeInput = document.querySelector('[name="properties[Ring Size]"]');
    state = { opts: v.options.slice(), size: sizeInput && sizeInput.value ? sizeInput.value : '', buy: !!buy, plating: window.__ivmPlating || 'White', platNA: false, mchosen: !!window.__ivmChosen };
    state.midx = -1;
    data.options.forEach(function (name, i) {
      var vals = []; data.variants.forEach(function (x) { if (vals.indexOf(x.options[i]) < 0) vals.push(x.options[i]); });
      if (state.midx < 0 && isMetal(name) && metalOk(vals)) { state.midx = i; state.mvals = vals; }
    });
    sheet.querySelector('.ivq__err').hidden = true;
    render();
    sheet.classList.add('is-open');
    document.documentElement.classList.add('ivq-lock');
    return true;
  }
  function close() {
    if (!sheet) return;
    sheet.classList.remove('is-open');
    document.documentElement.classList.remove('ivq-lock');
  }

  function onSheetClick(e) {
    var t = e.target;
    if (t.closest('[data-ivq-close]')) { close(); return; }
    var mt = t.closest('[data-m-tab], [data-m-val]');
    if (mt && state.midx > -1) {
      var mi = state.midx;
      var val = mt.hasAttribute('data-m-val') ? mt.getAttribute('data-m-val') : valueForTab(mt.getAttribute('data-m-tab'), state.mvals, state.opts[mi]);
      if (!val) { state.platNA = true; render(); return; }
      state.platNA = false;
      state.mchosen = true; window.__ivmChosen = true;
      state.opts[mi] = val;
      if (!findVariant(state.opts)) {
        var alt2 = data.variants.filter(function (x) { return x.options[mi] === val; })[0];
        if (alt2) state.opts = alt2.options.slice();
      }
      render(); return;
    }
    var mp = t.closest('[data-m-plate]');
    if (mp) { state.plating = mp.getAttribute('data-m-plate'); window.__ivmPlating = state.plating; render(); return; }
    var o = t.closest('[data-ivq-opt]');
    if (o && !o.disabled) {
      var idx = parseInt(o.getAttribute('data-ivq-opt'), 10);
      state.opts[idx] = o.getAttribute('data-val');
      if (!findVariant(state.opts)) {
        // pick the first variant that has this value
        var alt = data.variants.filter(function (x) { return x.options[idx] === state.opts[idx]; })[0];
        if (alt) state.opts = alt.options.slice();
      }
      render(); return;
    }
    var s = t.closest('[data-ivq-size]');
    if (s) {
      state.size = s.getAttribute('data-ivq-size');
      sheet.querySelector('.ivq__err').hidden = true;
      render(); return;
    }
    if (t.closest('.ivq__add')) addToCart();
  }

  function addToCart() {
    var v = findVariant(state.opts);
    var err = sheet.querySelector('.ivq__err');
    if (!v || !v.available) return;
    if (state.midx > -1 && !state.mchosen) {
      err.textContent = 'Please select a metal.';
      err.hidden = false;
      var mt2 = sheet.querySelector('.ivm__tabs');
      if (mt2) { mt2.classList.add('ivq-shake'); setTimeout(function () { mt2.classList.remove('ivq-shake'); }, 400); }
      return;
    }
    if (data.ring && !state.size) {
      err.textContent = 'Please select your ring size.';
      err.hidden = false;
      var sizes = sheet.querySelector('.ivq__sizes');
      if (sizes) { sizes.classList.add('ivq-shake'); setTimeout(function () { sizes.classList.remove('ivq-shake'); }, 400); }
      return;
    }
    var props = {};
    document.querySelectorAll('form[action*="/cart/add"] [name^="properties["]').forEach(function (inp) {
      var k = inp.name.slice(11, -1);
      if (inp.value && k !== 'Ring Size' && (inp.type !== 'checkbox' || inp.checked)) props[k] = inp.value;
    });
    if (data.ring) props['Ring Size'] = state.size;
    delete props.Plating;
    if (state.midx > -1 && state.mchosen && (parseMetal(state.opts[state.midx]) || {}).g === 'silver') props.Plating = state.plating + ' Gold Plated';
    if (state.platNA) return;
    var add = sheet.querySelector('.ivq__add');
    add.disabled = true; add.textContent = 'Adding…';
    fetch(root + 'cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: v.id, quantity: 1, properties: props }] })
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); }).then(function (res) {
      if (!res.ok) {
        err.textContent = res.j && (res.j.description || res.j.message) ? (res.j.description || res.j.message) : 'Could not add to cart. Please try again.';
        err.hidden = false; render(); return;
      }
      close();
      if (state.buy) { window.location.href = root + 'checkout'; return; }
      if (window.MinimogEvents && window.MinimogTheme && MinimogTheme.pubSubEvents) {
        try { MinimogEvents.emit(MinimogTheme.pubSubEvents.cartUpdate, { source: 'ivq' }); } catch (e) {}
      }
      var d = document.querySelector('m-cart-drawer');
      if (d && d.onCartDrawerUpdate) d.onCartDrawerUpdate(true);
      if (d && d.open) setTimeout(function () { d.open(); }, 150);
      if (window.ivdReconcile) setTimeout(window.ivdReconcile, 500);
    }).catch(function () {
      err.textContent = 'Network error. Please try again.'; err.hidden = false; render();
    });
  }

  // Intercept add to cart / buy now on phones
  document.addEventListener('click', function (e) {
    if (!MQ.matches) return;
    var b = e.target.closest && e.target.closest(BTN_SEL);
    if (!b) return;
    if (!document.querySelector('script[data-ivq]')) return;
    e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
    open(b.id === 'buy-it-now-btn1');
  }, true);

  // The theme disables add to cart until a ring size is picked; on phones the sheet handles that instead
  function keepEnabled() {
    if (!MQ.matches || !document.querySelector('script[data-ivq]')) return;
    if (!data) data = load();
    if (!data || !data.variants.some(function (x) { return x.available; })) return;
    document.querySelectorAll(BTN_SEL).forEach(function (b) {
      if (b.disabled) { b.disabled = false; b.classList.remove('disabled'); }
    });
  }
  window.addEventListener('load', function () {
    keepEnabled();
    new MutationObserver(keepEnabled).observe(document.body, { subtree: true, attributes: true, attributeFilter: ['disabled'] });
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

  /* ---------- Product page (all screens): replace the Metal Type buttons with tabs + circles ---------- */
  var pg = { platNA: false, need: false, chosen: /[?&]variant=/.test(location.search), err: false, draw: null };
  window.__ivmChosen = pg.chosen;
  function initPage() {
    var fields = document.querySelectorAll('.product__variant-picker [data-option-name]');
    var field = null;
    for (var i = 0; i < fields.length; i++) if (/metal/i.test(fields[i].getAttribute('data-option-name') || '')) { field = fields[i]; break; }
    if (!field || field.__ivm) return;
    var inputs = field.querySelectorAll('input[type="radio"]');
    var values = Array.prototype.map.call(inputs, function (x) { return x.value; });
    if (!metalOk(values)) return;
    field.__ivm = true;
    pg.need = true;
    field.classList.add('ivm-on');
    var box = document.createElement('div');
    box.className = 'ivm ivm--page';
    field.insertBefore(box, field.firstChild);
    var formId = inputs[0].getAttribute('form');
    var hid = document.createElement('input');
    hid.type = 'hidden'; hid.name = 'properties[Plating]';
    if (formId) hid.setAttribute('form', formId);
    field.appendChild(hid);
    function checked() { var c = field.querySelector('input[type="radio"]:checked'); return c ? c.value : values[0]; }
    function draw() {
      var cur = checked();
      if (window.__ivmChosen) pg.chosen = true;
      box.innerHTML = metalHTML(values, cur, window.__ivmPlating, pg.platNA, null, pg.chosen) + (pg.err && !pg.chosen ? '<p class="ivm__err">Please select a metal</p>' : '');
      var silver = pg.chosen && !pg.platNA && (parseMetal(cur) || {}).g === 'silver';
      hid.disabled = !silver;
      hid.value = silver ? window.__ivmPlating + ' Gold Plated' : '';
      if (window.bucksCC && typeof bucksCC.reConvert === 'function') { try { bucksCC.reConvert(); } catch (e) {} }
    }
    function choose(val) {
      for (var j = 0; j < inputs.length; j++) if (inputs[j].value === val) {
        var lab = field.querySelector('label[for="' + inputs[j].id + '"]');
        (lab || inputs[j]).click();
        if (!inputs[j].checked) { inputs[j].checked = true; inputs[j].dispatchEvent(new Event('change', { bubbles: true })); }
      }
    }
    box.addEventListener('click', function (e) {
      var b = e.target.closest('button');
      if (!b) return;
      e.preventDefault();
      pg.chosen = true; window.__ivmChosen = true; pg.err = false;
      if (b.hasAttribute('data-m-plate')) { window.__ivmPlating = b.getAttribute('data-m-plate'); draw(); return; }
      var val = b.hasAttribute('data-m-val') ? b.getAttribute('data-m-val') : valueForTab(b.getAttribute('data-m-tab'), values, checked());
      if (!val) { pg.platNA = true; draw(); return; }
      pg.platNA = false;
      if (val !== checked()) choose(val);
      setTimeout(draw, 30);
    });
    field.addEventListener('change', function () { setTimeout(draw, 30); });
    pg.draw = draw;
    draw();
  }
  // Desktop: a metal must be picked before add to cart / buy now
  document.addEventListener('click', function (e) {
    if (MQ.matches || !pg.need || pg.chosen) return;
    var b = e.target.closest && e.target.closest(BTN_SEL);
    if (!b) return;
    e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
    pg.err = true;
    if (pg.draw) pg.draw();
    var t = document.querySelector('.ivm--page .ivm__tabs');
    if (t) { t.classList.remove('ivq-shake'); void t.offsetWidth; t.classList.add('ivq-shake'); t.scrollIntoView({ block: 'center', behavior: 'smooth' }); }
  }, true);

  /* ---------- Phones: price + reviews on one line, compare + Save badge below, compact coupon chip ---------- */
  function mobilePrice() {
    if (!MQ.matches) return;
    var rp = document.querySelector('.prod__reviews-and-prices');
    if (!rp || rp.__ivp) return;
    rp.__ivp = true;
    rp.classList.add('ivp-on');
    var fp = rp.querySelector('.f-price');
    var badge = document.querySelector('.prod__title .jm-badge');
    if (fp && badge) {
      badge.classList.add('ivp-badge');
      var onSale = fp.classList.contains('f-price--on-sale');
      var holder = onSale ? fp.querySelector('.f-price__sale') : fp.querySelector('.f-price__regular');
      var priceEl = holder && holder.querySelector('.f-price-item');
      if (priceEl) priceEl.parentNode.insertBefore(badge, priceEl.nextSibling); else fp.appendChild(badge);
    }
    var box = rp.querySelector('[data-ivd-pdp]');
    if (!box) return;
    var chip = document.createElement('button');
    chip.type = 'button';
    chip.className = 'ivp-chip';
    chip.setAttribute('aria-label', 'Apply discount code');
    box.parentNode.insertBefore(chip, box.nextSibling);
    var applied = false;
    function sync() {
      var pay = box.querySelector('[data-ivd-pay]'), code = box.querySelector('[data-ivd-code]');
      chip.hidden = !!box.hidden;
      chip.innerHTML = '<span class="ivp-chip__pay">Pay ' + (pay ? pay.innerHTML : '') + '</span><span class="ivp-chip__code">' + (code ? esc(code.textContent) : '') +
        (applied ? ' &#10003;' : '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" aria-hidden="true"><rect x="9" y="9" width="12" height="12" rx="2"/><path d="M5 15V5a2 2 0 0 1 2-2h10"/></svg>') + '</span>';
    }
    sync();
    new MutationObserver(sync).observe(box, { subtree: true, childList: true, characterData: true, attributes: true });
    chip.addEventListener('click', function (e) {
      e.preventDefault();
      var code = box.querySelector('[data-ivd-code]');
      if (code && navigator.clipboard && navigator.clipboard.writeText) { try { navigator.clipboard.writeText(code.textContent); } catch (x) {} }
      var a = box.querySelector('[data-ivd-apply]');
      if (a) a.click();
      applied = true; sync();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mobilePrice); else mobilePrice();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initPage); else initPage();
})();
